module.exports = __webpack_public_path__ + "static/media/Community.3625cf2b.png";